export default {
    baseStyle: {
        filledTrack: {
            borderColor: 'gray.600',
            transitionProperty: 'width'
        },
        track: {
            height: '12px',
            borderRadius: '6px',
            border: '1px solid',
            borderColor: 'gray.500',
            backgroundColor: 'white'
        }
    },
    sizes: {
        gwp: {
            track: {
                height: '12px',
                borderRadius: '20px',
                margin: '5px 0',
                border: '1px solid',
                borderColor: 'gray.600',
                bg: 'white',
                width: '100%',
                colorScheme: 'green.300'
            }
        },
        discount: {
            track: {
                height: '12px',
                borderRadius: '20px',
                margin: '5px 0',
                border: '1px solid',
                borderColor: 'gray.600',
                bg: 'white',
                width: '100%',
                colorScheme: 'green.300'
            }
        }
    },
    variants: {
        yr: {
            filledTrack: {
                background: 'green.300'
            }
        },
        ks: {
            filledTrack: {
                background: 'yellow.600'
            }
        },
        ksGradient: {
            filledTrack: {
                background: 'linear-gradient(270deg, #EDDEFF 0%, #FFE9CB 52.6%, #F1E02B 100%)'
            }
        }
    }
}
